import Type from './type';

export default Type;
